/**
 * G14/G17 — one credential identity per request (Bearer XOR cookie jar).
 *
 * - Non-empty Bearer → `credentials:'omit'` + `Authorization: Bearer …`
 * - Empty / absent Bearer → `credentials:'include'` + zero Authorization
 *
 * Spec A cookie-first: callers pass `bearerToken: null` (never attach session Bearer).
 * Dual transitional: pass memory Bearer only when intentionally attaching.
 */

export type CustomerCredentialSend = {
  readonly credentials: RequestCredentials;
  /** Present only on the Bearer identity path — never with credentials include. */
  readonly authorizationHeader?: string;
};

export function resolveCustomerCredentialSend(args: {
  readonly bearerToken?: string | null;
}): CustomerCredentialSend {
  const token =
    typeof args.bearerToken === 'string' && args.bearerToken.length > 0
      ? args.bearerToken
      : null;
  if (token !== null) {
    return {
      credentials: 'omit',
      authorizationHeader: `Bearer ${token}`,
    };
  }
  return { credentials: 'include' };
}
